import { FEATURE_FLAGS_ACTIONS } from './featureFlags.types'

export const setFeatureFlagsStatusAction = payload => ({
  type: FEATURE_FLAGS_ACTIONS.SET_FEATURE_FLAGS_STATUS,
  payload
})

export const setFeatureFlagsErrorsAction = payload => ({
  type: FEATURE_FLAGS_ACTIONS.SET_FEATURE_FLAGS_ERRORS,
  payload
})

export const setFeatureFlagAction = payload => ({
  type: FEATURE_FLAGS_ACTIONS.SET_FEATURE_FLAG,
  payload
})

export const clearFeatureFlagsErrorsAction = () => ({
  type: FEATURE_FLAGS_ACTIONS.CLEAR_FEATURE_FLAGS_ERRORS
})
